var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 0.75V12.75M2.08333 0.75H11.4167C12.153 0.75 12.75 1.34695 12.75 2.08333V11.4167C12.75 12.153 12.153 12.75 11.4167 12.75H2.08333C1.34695 12.75 0.75 12.153 0.75 11.4167V2.08333C0.75 1.34695 1.34695 0.75 2.08333 0.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelLeftIcon);
export default __webpack_public_path__ + "static/media/panel-left-icon.b22251cd8a870a4c14927843d2102439.svg";
export { ForwardRef as ReactComponent };